import React from "react";
import { useBreakpoint } from "../../hooks/useResize";
import { i18n } from "@euroland/libs";
import { getCurrencyLabel } from "../../store/utils";
import useCurrencyName from "../../hooks/useCurrencyName";
import { formatNumberByInstrument } from "../../utils/format-number";
import TickerName from "../TickerName";

const QuadrataShowMultipleItems = ({ historicalShare = [], onClose }) => {
  const { isMobileScreen } = useBreakpoint();
  const getCurrencyName = useCurrencyName();
  return (
    <>
      {isMobileScreen ? (
        <>
          {historicalShare.map((item, index) => (
            <div className="quadrata-view-history quadrata-view-history-multiple" key={item.instrumentId}>
              {index === 0 ? (
                <button className="quadrata-view-history__close" onClick={onClose}>
                  <span
                    aria-hidden="false"
                    aria-label="Close card"
                    role="button"
                    class="fs-close fs-icon"
                  ></span>
                </button>
              ) : null}
              <div className="quadrata-view-history__row">
                <div className="quadrata-view-history__col">
                  <p className="quadrata-view-history__title">
                    <TickerName shareName={item.shareName} marketAbbreviation={item.marketAbbreviation} />
                  </p>

                  <div className="quadrata-view-history__item">
                    <div className="quadrata-view-history__name">{i18n.translate("lastPrice")}</div>
                    <div className="quadrata-view-history__value">
                      {formatNumberByInstrument(item.close, item.instrumentId)}
                    </div>
                  </div>
                  <div className="quadrata-view-history__item">
                    <div className="quadrata-view-history__name">{i18n.translate("market")}</div>
                    <div className="quadrata-view-history__value">{item.marketName}</div>
                  </div>
                  <div className="quadrata-view-history__item">
                    <div className="quadrata-view-history__name">{i18n.translate("currency")}</div>
                    <div className="quadrata-view-history__value" aria-label={getCurrencyName(item.currency)}>
                      {getCurrencyLabel(item.currency)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </>
      ) : (
        <div className="quadrata-view-history quadrata-view-history-multiple">
          <button className="quadrata-view-history__close" onClick={onClose}>
            <span aria-hidden="false" aria-label="Close card" role="button" class="fs-close fs-icon"></span>
          </button>
          <div className="quadrata-view-history__row">
            {historicalShare?.length > 0 &&
              historicalShare.map(item => (
                <div className="quadrata-view-history__col" key={item.instrumentId}>
                  <p className="quadrata-view-history__title">
                    <TickerName shareName={item.shareName} marketAbbreviation={item.marketAbbreviation} />
                  </p>

                  <div className="quadrata-view-history__item">
                    <div className="quadrata-view-history__name">{i18n.translate("lastPrice")}</div>
                    <div className="quadrata-view-history__value">
                      {formatNumberByInstrument(item.close, item.instrumentId)}
                    </div>
                  </div>
                  <div className="quadrata-view-history__item">
                    <div className="quadrata-view-history__name">{i18n.translate("market")}</div>
                    <div className="quadrata-view-history__value">{item.marketName}</div>
                  </div>
                  <div className="quadrata-view-history__item">
                    <div className="quadrata-view-history__name">{i18n.translate("currency")}</div>
                    <div
                      className="quadrata-view-history__value"
                      aria-label={getCurrencyName(item.currency)}
                      role="note"
                    >
                      {getCurrencyLabel(item.currency)}
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      )}
    </>
  );
};

export default QuadrataShowMultipleItems;
